import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Link } from 'react-router-dom';
import api from '../../../services/api';
import { ButtonPanel, Container, Table } from './styles';

import Button from '../../../components/Button';
import Loading from '../../../components/Loading';

export default class Administrators extends Component {
  state = {
    admins: [],
    alert: {},
    loading: true,
    showAlert: false,
  };

  componentDidMount() {
    this.loadAdmins();
  }

  deleteAdmin = async (id) => {
    const { admins } = this.state;
    try {
      await api.delete(`admin/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
      });

      this.setState({ admins: admins.filter(admin => admin.id !== id) });
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível excluir o administrador. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  loadAdmins = async () => {
    try {
      const { data } = await api.get('admins', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
        params: {
          results: 0,
        },
      });

      this.setState({ admins: data.admins, loading: false });
    } catch (err) {
      const messages = err.response
        ? err.response.data.errors
        : ['Não foi possível carregar os administradores. Por favor, atualize a página.'];
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages,
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  render() {
    const {
      admins,
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      loading,
      showAlert,
    } = this.state;

    return (
      <Fragment>
        {loading ? (
          <Loading />
        ) : (
          <Container>
            <div className="row">
              <div className="col-12">
                <h1 className="page-title">Administradores {admins && ` (${admins.length})`}</h1>
                <ButtonPanel>
                  <Link to="/admin/dashboard/administrators/create" className="btn btn-success">
                    Cadastrar novo
                  </Link>
                </ButtonPanel>
              </div>
            </div>
            <div className="box">
              <div className="row">
                <div className="col-12">
                  {admins.length > 0 ? (
                    <div className="table-wrapper">
                      <Table className="table">
                        <thead>
                          <tr>
                            <th>Nome</th>
                            <th>Email</th>
                            <th>Excluir</th>
                          </tr>
                        </thead>
                        <tbody>
                          {admins.map(admin => (
                            <tr key={admin.id}>
                              <td>{admin.name}</td>
                              <td>{admin.email}</td>
                              <td>
                                <Button
                                  onClick={() => this.deleteAdmin(admin.id)}
                                  className="btn-outline-secondary btn-small"
                                >
                                  <FontAwesomeIcon icon={faTimes} />
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  ) : (
                    <h5 className="text-center">Não existem administradores cadastrados.</h5>
                  )}
                </div>
              </div>
            </div>
            {showAlert && (
              <SweetAlert
                type={type}
                confirmBtnText={confirmBtnText}
                confirmBtnBsStyle={confirmBtnBsStyle}
                showCancel={showCancel}
                cancelBtnText={cancelBtnText}
                cancelBtnBsStyle={cancelBtnBsStyle}
                title={title}
                onConfirm={onConfirm}
                onCancel={this.closeAlert}
              >
                <ul>
                  {messages.map(msg => (
                    <li key={msg}>{msg}</li>
                  ))}
                </ul>
              </SweetAlert>
            )}
          </Container>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/pages/Administrators/index.js